import { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { AppErrorFallback } from '@/components/AppErrorFallback';

/**
 * Route-level error element. With createBrowserRouter, a render error inside a
 * route is caught by react-router's own boundary, never by the
 * Sentry.ErrorBoundary wrapped around the RouterProvider — so fan-page crashes
 * showed react-router's default "Unexpected Application Error!" and never
 * reached Sentry. This reports the error and shows the same fallback as the
 * app-level boundary. A plain reload keeps localStorage, so the fan's order
 * pointer survives the crash.
 */
export function RouteErrorFallback() {
  const error = useRouteError();
  const [eventId, setEventId] = useState<string | undefined>();

  useEffect(() => {
    setEventId(Sentry.captureException(error, { tags: { boundary: 'route' } }));
  }, [error]);

  return <AppErrorFallback error={error} eventId={eventId} resetError={() => window.location.reload()} />;
}
